<template>
  <div>
    <div class="containar">
      <div class="contents-block">
        <div class="preview-area">
          <div class="preview-header">
            <h3>プレビュー</h3>
          </div>
          <ul class="flex-containar-2">
            <li class="voice-state-2">
              <div class="avatar-wrapper" v-bind:style="{boxShadow: '0 0 0 8px ' + subColor.hex + ', 0 0 0 12px ' + mainColor.hex}">
                <img class="img-2 color1" :src="imgPath">
              </div>
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: mainColor.hex}">User1</span>
              </div>
            </li>
            <li class="voice-state-2">
              <div class="avatar-wrapper" v-bind:style="{boxShadow: '0 0 0 8px ' + subColor.hex + ', 0 0 0 12px ' + mainColor.hex}">
                <img class="img-2 color2" :src="imgPath">
              </div>
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: mainColor.hex}">User2</span>
              </div>
            </li>
            <li class="voice-state-2">
              <div class="avatar-wrapper" v-bind:style="{boxShadow: '0 0 0 8px ' + subColor.hex + ', 0 0 0 12px ' + mainColor.hex}">
                <img class="img-2 color3" :src="imgPath">
              </div>
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: mainColor.hex}">User3</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="set">
          <h3>カラープリセット</h3>
          <div class="preset-row">
            <button 
              v-for="(preset, index) in presets" 
              :key="index"
              class="preset-btn"
              :class="{ active: mainColor.hex === preset.main && subColor.hex === preset.sub }"
              @click="applyPreset(preset)"
              :title="preset.name"
            >
              <span class="preset-color preset-main" :style="{background: preset.main}"></span>
              <span class="preset-color preset-sub" :style="{background: preset.sub}"></span>
            </button>
          </div>

          <h3>カラー設定</h3>
          <div class="color-row">
            <label class="color-item">
              <span class="color-label">メイン</span>
              <div class="color-input-wrapper">
                <input type="color" v-model="mainColor.hex" class="color-native">
                <span class="color-preview" :style="{background: mainColor.hex}"></span>
                <input type="text" v-model="mainColor.hex" class="color-hex-input" maxlength="7">
              </div>
            </label>
            <label class="color-item">
              <span class="color-label">サブ</span>
              <div class="color-input-wrapper">
                <input type="color" v-model="subColor.hex" class="color-native">
                <span class="color-preview" :style="{background: subColor.hex}"></span>
                <input type="text" v-model="subColor.hex" class="color-hex-input" maxlength="7">
              </div>
            </label>
          </div>
          
          <h3>コピペ用CSS</h3>
          <div class="url-description">
            <p>DiscordオーバレイのカスタムCSSです。</p>
            <p><a href="https://streamkit.discord.com/overlay" target="_blank" rel="noopener noreferrer">streamkit</a>でDiscordのボイスチャンネルのURLを取得→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
            <p><a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">さらに詳しい使い方はこちら</a></p>
          </div>
          <div class="url-container">
            <textarea id="target" readonly class="url-input textarea" v-model="resultCSS" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      mainColor: { hex: '#F9A8D4' },
      subColor: { hex: '#FECDD3' },
      presets: [
        // ピンク系
        { name: 'ベビーピンク', main: '#F9A8D4', sub: '#FECDD3' },
        { name: 'さくらもち', main: '#FDA4AF', sub: '#FFE4E6' },
        { name: 'ストロベリー', main: '#FB7185', sub: '#FECDD3' },
        // ブルー系
        { name: 'そらいろ', main: '#7DD3FC', sub: '#BAE6FD' },
        { name: 'みずいろ', main: '#67E8F9', sub: '#CFFAFE' },
        { name: 'ラベンダー', main: '#C4B5FD', sub: '#E9D5FF' },
        // グリーン・イエロー系
        { name: 'ミント', main: '#A8DF8E', sub: '#F0FFDF' },
        { name: 'れもん', main: '#FF9B00', sub: '#FFC900' },
        { name: 'ピーチ', main: '#FDBA74', sub: '#FED7AA' },
        // ニュートラル系
        { name: 'ミルクティー', main: '#D4A574', sub: '#E8D5C4' },
        { name: 'グレージュ', main: '#A8A29E', sub: '#D6D3D1' },
        { name: 'くもいろ', main: '#94A3B8', sub: '#CBD5E1' },
      ],
    };
  },
  methods: {
    applyPreset(preset) {
      this.mainColor.hex = preset.main;
      this.subColor.hex = preset.sub;
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.resultCSS)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
  computed: {
    resultCSS(){
        return "@import url('https://fonts.googleapis.com/css2?family=Zen+Maru+Gothic:wght@300&display=swap');*{font-family: \"Zen Maru Gothic\", sans-serif!important;}[class*='Voice_voiceStates__']{list-style-type:none;padding:20px 0 0 0;display: flex;flex-direction: row;align-items: flex-start;justify-content:center;gap: 32px;margin: 0 auto;width: 100%;max-width:100%;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:auto;margin-bottom:20px;}[class*='Voice_voiceStates__'] li {width: var(--avatar-size);box-sizing: border-box;padding: 0;margin: 0;position: relative;}[class*='Voice_avatar__']{width:var(--avatar-size);height:var(--avatar-size);border-radius:12px;filter:brightness(90%);transition: filter 180ms ease-in-out;float:none;position: relative;z-index: 1;display: block;border:none!important;outline: none!important;box-shadow:none!important;}[class*='Voice_voiceStates__'] li::before{content:\"\";position:absolute;top:0;left:0;width:var(--avatar-size);height:var(--avatar-size);border-radius:12px;box-shadow:0 0 0 8px var(--sub-color),0 0 0 12px var(--main-color);z-index:0;pointer-events:none;}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(100%)!important;transition: filter 180ms ease-in-out;border-color:var(--trans)!important;}[class*='Voice_user__']{margin-top:-28px;}[class*='Voice_name__']{text-align:center;background: var(--main-color)!important;color:#fff!important;font-size: 16px!important;opacity:var(--name-opacity)!important;border-radius:0 0 12px 12px;padding:16px 12px 0 12px;display:block;line-height: 2;margin: 0 auto!important;width: fit-content;max-width:96px;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}:root {--avatar-size:124px;--main-color:" + this.mainColor.hex + ";--sub-color:" + this.subColor.hex + ";}ul li{margin-top:30px;display: block;}";
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Zen+Maru+Gothic:wght@300&display=swap');

/* Base */
p { margin: 0; padding: 0; font-size: 14px; }
h3 { font-size: 14px; margin: 24px 0 0; }
.containar { margin: 0 auto; width: 100%; }

/* Layout */
.contents-block {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 24px auto;
  gap: 24px;
}

/* Preview (左側) */
.preview-area {
  flex: 1;
  min-width: 420px;
  border-radius: 12px;
  padding: 16px;
  order: 1;
}

/* Settings (右側) */
.set {
  flex: 0 0 360px;
  padding: 8px 12px 24px;
  background-color: #FFFEF9;
  border-radius: 10px;
  order: 2;
}

.preview-header { padding: 2px 12px; margin-bottom: 8px; }
.preview-header h3 { margin: 0; }

.flex-containar-2 {
  min-height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 24px 16px;
  margin: 0;
  box-sizing: border-box;
}

.voice-state-2 {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 96px;
  position: relative;
}

.avatar-wrapper,
.img-2 {
  width: 96px;
  height: 96px;
  border-radius: 12px;
  position: relative;
  z-index: 0;
}

.img-2 {
  object-fit: scale-down;
  padding: 5px;
  box-sizing: border-box;
  z-index: 1;
  display: block;
  border: none;
  outline: none;
  box-shadow: none;
}

.color1 { background-color: #5865F2; }
.color2 { background-color: #EB459E; }
.color3 { background-color: #57F287; }

.name-box-2 {
  margin: -16px 0 0;
  color: white;
  width: 96px;
  text-align: center;
  
}

.name-2 {
  padding:22px 12px 0;
  color: white;
  font-size: 14px;
  font-family: "Zen Maru Gothic", sans-serif;
  border-radius: 0 0 12px 12px;
  display: block;
  line-height: 2;
  margin: 0 auto;
  width: fit-content;
  max-width: 96px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/* Color Presets */
.preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.preset-btn {
  display: flex;
  gap: 2px;
  padding: 4px;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.preset-btn:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.preset-btn.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.1);
}

.preset-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.preset-main { border-radius: 4px 0 0 4px; }
.preset-sub { border-radius: 0 4px 4px 0; }

/* Color Picker */
.color-row {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.color-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.color-label {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.color-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: border-color 0.2s;
}

.color-input-wrapper:hover { border-color: #cbd5e1; }
.color-input-wrapper:focus-within { border-color: #0f172a; }

.color-native {
  position: absolute;
  width: 32px;
  height: 32px;
  opacity: 0;
  cursor: pointer;
}

.color-preview {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.1) inset;
  cursor: pointer;
  flex-shrink: 0;
}

.color-hex-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 13px;
  color: #334155;
  text-transform: uppercase;
  padding: 0;
}

.color-hex-input:focus { outline: none; }

/* URL Section */
.url-description { margin: 12px 0 16px; }
.url-description p { font-size: 13px; color: #718096; margin: 0 0 6px; line-height: 1.5; }
.url-description a { color: #0f172a; text-decoration: underline; }
.url-description a:hover { color: #1e293b; }

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
}

.url-input.textarea { height: 80px; padding: 12px; resize: vertical; }
.url-input:focus { outline: none; box-shadow: 0 0 0 2px #0f172a; }

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover { transform: translateY(-1px); }
.url-copy-btn:active { transform: translateY(0); }

/* Responsive */
@media screen and (max-width: 900px) {
  .contents-block { flex-wrap: wrap; }
  .preview-area { min-width: 100%; order: 1; }
  .set { flex: 1 1 100%; order: 2; margin-top: 0; }
}

@media screen and (max-width: 600px) {
  .preview-area { overflow-x: auto; }
  .flex-containar-2 { gap: 24px; min-width: 400px; }
}
</style>